import { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

const useInterruptRouting = (step) => {
  const { t } = useTranslation(['common']);
  const { events } = useRouter();
  const [isStepReset, setStepReset] = useState(false);

  useEffect(() => {
    const handleWindowClose = (evt) => {
      evt.preventDefault();
      return (evt.returnValue = t('common:modal.question-interrupt'));
    };

    if (step > 1) {
      window.addEventListener('beforeunload', handleWindowClose);
      events.on('routeChangeStart', handleOpenModal);
    }

    return () => {
      window.removeEventListener('beforeunload', handleWindowClose);
      events.off('routeChangeStart', handleOpenModal);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const handleOpenModal = (url, { shallow } = {}) => {
    // Shallow-переход — это смена query на той же странице (напр. очистка
    // ?tool= в PdfEditor через router.replace(..., { shallow: true })), а не
    // уход из редактора: несохранённая работа не теряется, перехватывать не
    // нужно. Иначе пользователь сразу после открытия панели видит confirm на
    // пустом месте, а Cancel роняет router.replace необработанным reject.
    if (shallow) {
      return;
    }

    if (window.confirm(t('common:modal.question-interrupt'))) {
      setStepReset(true);
      return true;
    } else {
      const message = 'change route stopped';
      throw message;
    }
  };

  return [isStepReset, setStepReset];
};

export default useInterruptRouting;
